import React, { createContext, useContext, useState } from 'react';
import auth, { validateJwtToken } from '../services/auth.services';
import { TUserCredentials, TJWTProfile } from '../types/auth';
import { AxiosResponse } from 'axios';

type ucProps = {
    children: React.ReactNode;
};

export type TAuthContext = {
    user: TJWTProfile | null;
    login: (uc: TUserCredentials) => Boolean;
    logout: () => Promise<AxiosResponse<any>>;
    authorized: () => Boolean;
};
const AuthContext = createContext<TAuthContext | any>({});

function useProvideAuth() {
    const [user, setUser] = useState<TJWTProfile | null>(null);
    const login = (uc: TUserCredentials) => {
        auth.login(uc)
            .then((res) => {
                let user = validateJwtToken(res.data.data.accessToken);
                if (user !== null) {
                    setUser(user);
                }
                return true;
            })
            .catch((err) => {
                console.log(err);
                return false;
            });
    };
    const logout = () => auth.logout();
    const authorized = (): Boolean => {
        let jwt = validateJwtToken(localStorage.getItem('accessToken'));
        if (jwt !== null) {
            if (user === null) setUser(jwt);
            return true;
        } else {
            return false;
        }
    };
    return {
        user,
        login,
        logout,
        authorized
    };
}

const AuthContextProvider = function (props: ucProps) {
    const auth = useProvideAuth();
    return <AuthContext.Provider value={auth}>{props.children}</AuthContext.Provider>;
};

export const UseAuth = function (): TAuthContext {
    return useContext(AuthContext);
};

export default AuthContextProvider;
